/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementEditItemQuantityResponse } from './CarpsaleManagementEditItemQuantityResponse';

export type CarpsaleManagementEditItemQuantityResponseApiRespoonse = {
    data?: CarpsaleManagementEditItemQuantityResponse;
    status?: CarpsaleManagementEditItemQuantityResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementEditItemQuantityResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

